export default {
  'Favarite audience': 'Favarite audience',
  'Favarite exhibit': 'Favarite exhibit',
  'Favarite exhibitor': 'Favarite exhibitor',
  'No employee was added in this company for chat at the moment': 'No contact of this company for message or invitation now'
}